import React, { FC, Ref, ElementType, CSSProperties } from 'react';
import cn from 'classnames';
require("./Gradient.css");
var styles = {
  "Root": "Gradient-module-Root_3cB",
  "firstTestGradient": "Gradient-module-firstTestGradient_1Pm",
  "exampleGradient": "Gradient-module-exampleGradient_2Dy",
  "exampleGradient2": "Gradient-module-exampleGradient2_2St",
  "opacityBgGradient": "Gradient-module-opacityBgGradient_18J"
};
export const cnGradient = cn('Gradient');
export const Gradient = ({
  className,
  gradientName = '',
  tag = 'div',
  innerRef,
  controlRef,
  ...props
}) => {
  const Component = tag;
  return /*#__PURE__*/React.createElement(Component, {
    className: cn(styles.Root, styles[gradientName], className),
    ref: innerRef || controlRef
  }, props.children);
};
if (process.env.NODE_ENV !== 'production') {
  Gradient.displayName = 'Gradient';
}